var BookapiPaymentsResponse = /** @class */ (function () {
    function BookapiPaymentsResponse() {
        this.isOk = false;
        this.bookapiPayments = new Map();
    }
    BookapiPaymentsResponse.prototype.setIsOk = function (state) {
        this.isOk = state;
    };
    BookapiPaymentsResponse.prototype.getIsOk = function () {
        return this.isOk;
    };
    BookapiPaymentsResponse.prototype.addBookapiPayment = function (key, bookapiPayment) {
        this.bookapiPayments.set(key, bookapiPayment);
    };
    BookapiPaymentsResponse.prototype.getBookapiPayments = function () {
        return this.bookapiPayments;
    };
    return BookapiPaymentsResponse;
}());
export { BookapiPaymentsResponse };
